import { Backdrop } from '@pets-ui/Backdrop/Backdrop'
import { ButtonBase } from '@pets-ui/ButtonBase/ButtonBase'
import { HStack } from '@pets-ui/HStack/HStack'
import { ArrowDownSmall } from '@pets-ui/Icons'
import { Paper } from '@pets-ui/Paper/Paper'
import { Popper, type PopperProps } from '@pets-ui/Popper/Popper'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { zIndex } from '@pets-ui/tokens/zIndex.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { useEffect, useState } from 'react'
import { CategoryHighlight } from './CategoryHighlight'
import { type Category } from './CategoryTabs'

const styles = stylex.create({
  category: {
    padding: '4px 8px',
    borderRadius: 14,
    backgroundColor: colors.grey100,
    position: 'relative',
  },
  categoryActive: {
    backgroundColor: colors.primary100,
    color: colors.primary600,
  },
  iconActive: {
    transform: 'rotate(180deg)',
  },
  popper: {
    zIndex: zIndex.fab,
  },
})

export interface CategoryTabsDropdownProps {
  anchorEl: PopperProps['anchorEl']
  categories: Category[]
  activeCategory: string
  isExpand: boolean
  onChange: (category: Category) => void
  onToggle: () => void
}

export const CategoryTabsDropdown = (props: CategoryTabsDropdownProps) => {
  const { anchorEl, categories, activeCategory, isExpand, onChange, onToggle } = props
  const [width, setWidth] = useState(0)

  useEffect(() => {
    const handleResize = () => {
      if (anchorEl) {
        setWidth(anchorEl.getBoundingClientRect().width)
      }
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [anchorEl])

  return (
    <>
      <Popper
        open={isExpand}
        anchorEl={anchorEl}
        placement="top-start"
        offset={[0, -1]}
        strategy="fixed"
        {...stylex.props(styles.popper)}
      >
        <Paper width={width} borderRadius={0} borderBottomLeftRadius={8} borderBottomRightRadius={8}>
          <VStack>
            <HStack justifyContent="space-between" p={3}>
              <Text>請選擇分類</Text>
              <ButtonBase onClick={onToggle}>
                <ArrowDownSmall fontSize={20} color={colors.grey500} rootStyle={isExpand && styles.iconActive} />
              </ButtonBase>
            </HStack>
            <HStack gap={2} p={3}>
              {categories.map(category => (
                <ButtonBase
                  key={category.value}
                  onClick={() => onChange(category)}
                  rootStyle={[
                    styles.category,
                    activeCategory === category.value && styles.categoryActive,
                  ]}
                >
                  {category.label}
                  {category.highlight && <CategoryHighlight top={3} right={5} />}
                </ButtonBase>
              ))}
            </HStack>
          </VStack>
        </Paper>
      </Popper>
      <Backdrop open={isExpand} onClick={onToggle} zIndex={1} />
    </>
  )
}
